<div class="field field-image">



  @if (label) {
    <span class="label" [class.hide-text]="hideLabel">{{label}} @if (optionalString) {
      <span class="optional-string">({{optionalString}})</span>
    }</span>
  }
  <div>
    @if (!file && !url) {
      <div class="file-input" ngfSelect [(file)]="file2" (filesChange)="fileChange()" accept="image/*" ngfDrop>
        <i class="im-icon im-icon-image"><span>Afbeelding uploaden ...</span></i>
        <button class="image-input-button" type="button">Afbeelding zoeken</button>
      </div>
    }
    @if (file || url) {
      <div class="d-flex position-relative image-field-preview" style="margin-left: 5px;margin-right: 5px;">
        @if (file) {
          <img class="editor-image-preview" draggable="false" [ngfSrc]="file">
        }
        @if (url) {
          <img class="editor-image-preview" draggable="false" [src]="url">
        }
        <div class="editor-image-overlay d-flex align-items-center justify-content-center">
          <span ngfSelect [(file)]="file2" (filesChange)="fileChange()" accept="image/*"><i class="icon icon-image-edit"></i></span>
          <span (click)="removeImage()"><i class="icon icon-image-delete"></i></span>
        </div>
      </div>
    }
  </div>

  @if (error) {
    <span class="error-field-display">{{error}}</span>
  }
</div>